import { useTranslation } from "react-i18next";
import { Label } from "@/components/ui/label";
import { Select } from "@/components/ui/select";
import { cn } from "@jbnl/shared-ui";
import type { Inschrijfperiode } from "./useInschrijfperiodes";

interface Props {
  id: string;
  periodes: Inschrijfperiode[];
  gekozen: string | undefined;
  onKies: (inschrijfperiodeId: string) => void;
  className?: string;
}

/**
 * The window a namens screen writes under. Every periode is offered, open or shut: a stand-in is
 * exactly who reaches a closed one (ADR-0031).
 */
export function InschrijfperiodeKiezer({
  id,
  periodes,
  gekozen,
  onKies,
  className,
}: Props) {
  const { t } = useTranslation("inschrijfperiodes");

  return (
    <div className={cn("grid gap-2", className)}>
      <Label htmlFor={id}>{t("kiezer.label")}</Label>
      <Select
        id={id}
        value={gekozen ?? ""}
        onChange={(event) => onKies(event.target.value)}
      >
        {periodes.map((periode) => (
          <option key={periode.id} value={periode.id}>
            {periode.isOpen
              ? periode.name
              : t("kiezer.gesloten", { naam: periode.name })}
          </option>
        ))}
      </Select>
    </div>
  );
}
